import { render, staticRenderFns } from "./OfflineMeetingDetail.vue?vue&type=template&id=2c5d44a7&"
import script from "./OfflineMeetingDetail.vue?vue&type=script&lang=js&"
export * from "./OfflineMeetingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports